import { VersionStatus } from "../../config/Enums";

export class AddVersionCommand {
  public PageVersionId: number = 0;
  public PageId: number = 0;
  public Version: number = 0;
  public Status: VersionStatus = VersionStatus.Draft;
  public ViewLayout: string = "";
  public SiteId: string = "";
}